import * as  guid from "guid-typescript";
import moment from 'moment';


export const Guid: typeof guid.Guid = guid.Guid;

export function Log( lg: any ) {
    console.log( lg );
}

export function Wait( milliseconds: number ) {
    return new Promise( resolve => setTimeout( resolve, milliseconds ) );
}


export function formatearCodigoArticulo( Codigo: string ): string {
    if ( Codigo ) {
        Codigo = Codigo.toUpperCase();
        Codigo = Codigo.borraLetras();
        Codigo = Codigo.eliminar( " " );
        Codigo = Codigo.eliminar( "/" );
        Codigo = Codigo.eliminar( "-" );
        Codigo = Codigo.eliminar( "_" );
        Codigo = Codigo.eliminar( ":" );
        Codigo = Codigo.padCeros( 6 );
        Codigo = Codigo.insertar( 5, "/" );
    }
    return Codigo;
}

class random {

    protected auxiliar( min: number, max: number ): number {
        return Math.floor( Math.random() * ( max - min ) ) + min;
    }
    public Enteros( min: number, max: number ): number {
        return Math.floor( Math.random() * ( max - min ) ) + min;
    }

}
export const Random = new random();

export function getDropedFiles(e: any): any[] {

    let droppedFiles = e.dataTransfer.files;
    if ( !droppedFiles ) return;
    let files: any[] = [];
    ( [...droppedFiles] ).forEach( f => {
        files.push( f );
    } );

    return files;

}